import React, { useEffect, useState } from 'react';
import ModalFormPackage from '../../components/forms/config/modal.form.packages';
import ListTables from '../../components/shared/tables';
import Base from '../base';
import { Alert, Button } from '@themesberg/react-bootstrap';
import { get, del } from '../../services/back.service';

function ListPackages() {
  const [msgGet, setMsgGet] = useState('');
  const [Packages, setPackages] = useState([]);
  const [AvailableServiceTypes, setAvailableServiceTypes] = useState([]);
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: ''
  });
  useEffect(() => {
    getPackages();
  }, []);

  const createPackage = (variant, msg) => {
    setAlert({ show: true, message: msg, type: variant });
    getPackages();
  };

  const editButton = (row) => {
    return (
      <ModalFormPackage
        title="Modificar Paquete"
        button_text="Editar"
        button_variant="outline-primary"
        packageSelect={row.id}
        callback={createPackage}
        infoServiceTypes={AvailableServiceTypes}
      ></ModalFormPackage>
    );
  };

  const deleteButton = (row) => {
    return (
      <Button
        variant="outline-danger"
        size="sm"
        onClick={() => handleDelete(row.id, row.name)}
      >
        Eliminar
      </Button>
    );
  };

  const handleDelete = async (id, name) => {
    if (window.confirm(`¿Está seguro de eliminar el paquete "${name}"?`)) {
      const response = await del(`/config/package/delete/${id}`);
      if (response.success) {
        setAlert({ show: true, message: 'Paquete eliminado correctamente', type: 'success' });
        getPackages();
      } else {
        setAlert({ show: true, message: response.data || 'Error al eliminar', type: 'danger' });
      }
    }
  };

  const getPackages = async () => {
    const responsePackage = await get('/config/package/', {});
    if (responsePackage.success) {
      setPackages(responsePackage.data.packages);
      setAvailableServiceTypes(responsePackage.data.all_service_types);
    } else {
      setMsgGet(responsePackage.data);
    }
  };

  return (
    <Base>
      {alert.show && <Alert variant={alert.type} onClose={() => setAlert({ show: false })} dismissible>{alert.message}</Alert>}
      <ModalFormPackage
        title="Crear Paquete"
        button_text="Crear Paquete"
        button_variant="primary"
        callback={createPackage}
        infoServiceTypes={AvailableServiceTypes}
      ></ModalFormPackage>
      <ListTables
        data={Packages}
        editar={editButton}
        eliminar={deleteButton}
        messageWd={msgGet}
      />
    </Base>
  );
}

export default ListPackages;
